import {InferType} from 'yup';

import {mapStakeFromBackend} from '@entities/stake';
import {getBackendCurrencyValue, getDateFromIsoString} from '@shared/api';
import {Pool} from '../types';
import {poolSchema} from './backendSchemas';

export const mapPool = (pool: InferType<typeof poolSchema>): Pool => ({
  groupId: pool.group_id,
  topicId: pool.topic_id,
  status: pool.status,
  real: getBackendCurrencyValue(pool.real)!,
  promo: getBackendCurrencyValue(pool.promo)!,
  participants: pool.participants,
  winnerEventId: pool.winner_event_id,
  payable: getBackendCurrencyValue(pool.payable),
  winnerTotal: getBackendCurrencyValue(pool.winner_total),
  created: getDateFromIsoString(pool.created_at),
  updated: getDateFromIsoString(pool.updated_at),
  outcomes: pool.outcomes.map(outcome => ({
    eventId: outcome.event_id,
    eventSlug: outcome.event_slug,
    eventStatus: outcome.event_status,
    real: getBackendCurrencyValue(outcome.real)!,
    promo: getBackendCurrencyValue(outcome.promo)!,
    participants: outcome.participants,
    voided: outcome.voided,
  })),
  stakes: pool.stakes?.map(mapStakeFromBackend),
});
